var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 150,
    viewBox: "0 0 154 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 149.6C118.111 149.6 151.6 116.111 151.6 74.8C151.6 33.4891 118.111 0 76.8 0C35.4891 0 2 33.4891 2 74.8C2 116.111 35.4891 149.6 76.8 149.6Z",
    fill: "url(#paint0_linear_348_9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.4 59.0011C108 58.5011 107.8 58.3011 107 57.6011C103.9 55.0011 100.6 55.5011 97.7 54.6011C93.4 53.2011 93.6 49.9011 89.6 46.6011C82.5 40.8011 70.2 40.9011 63.9 46.7011C60.6 49.8011 60.3 52.5011 56.6 54.2011C53.1 55.9011 49.3 54.8011 45.9 58.2011C45.4 58.7011 45.1 59.1011 44.9 59.4011C42.5 63.1011 41 67.5011 41 72.3011V84.9011C41 97.3011 50.6 107.301 62.3 107.301H91.2C103 107.301 112.5 97.3011 112.5 84.9011V72.3011C112.6 67.6011 110.8 62.7011 108.4 59.0011ZM91 85.4011C90.2 87.4011 89 89.2011 87.3 90.6011C85.6 92.2011 83.8 93.3011 81.6 93.8011C79.6 94.7011 77.5 95.0011 75.2 94.8011C72.3 94.6011 69.7 93.7011 67.2 92.2011L63.9 89.4011C61.9 87.2011 60.5 84.6011 59.9 81.6011L59.6 77.3011C59.7 75.1011 60.2 73.1011 61.3 71.2011C62.1 69.2011 63.3 67.4011 65 66.0011C66.7 64.4011 68.5 63.3011 70.7 62.8011C72.7 61.9011 74.8 61.6011 77.1 61.8011C80 62.0011 82.6 62.9011 85.1 64.4011C86.2 65.3011 87.3 66.2011 88.4 67.2011C90.4 69.4011 91.8 72.0011 92.4 75.0011C92.5 76.4011 92.6 77.8011 92.7 79.3011C92.7 81.5011 92.1 83.6011 91 85.4011Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_9",
    x1: 23.8641,
    y1: 127.726,
    x2: 129.658,
    y2: 21.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1038,
    stopColor: "#5AD965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3273,
    stopColor: "#5EDB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#69E16F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "#7CEC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9486,
    stopColor: "#97FB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FFF94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.86a7f206790d293b60023c6eb239cdb6.svg";
export { ForwardRef as ReactComponent };